<router-outlet></router-outlet>
<ng-container #dynComp />
